import { render, staticRenderFns } from "./AccountSelector.vue?vue&type=template&id=fb4a7660"
import script from "./AccountSelector.vue?vue&type=script&lang=ts"
export * from "./AccountSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports